export default __webpack_public_path__ + "static/diploma-icon--green-c327abef093481be4bd139c9c501950f.svg";